module.exports = __webpack_public_path__ + "assets/img/6689cffb05f2c59e13e98a0671648a63.svg";